import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

export interface UserInfoModel {
  /**
   * 医療機関コード
   */
  hospitalId: string;
  /**
   * ユーザー名
   */
  username: string;
  /**
   * 表示名（ログインAPI返却の userName）
   */
  displayName?: string;
  /**
   * パスワード
   */
  password: string;
  /**
   * 診療科ID
   */
  departmentId: string;
  /**
   * /api/v1/login の hospitalType（HOSPITAL | FACILITY など）
   */
  hospitalType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  secretKey: string = environment.SECRET_KEY;

  constructor() { }
  
  /**
   * AES(Advanced Encryption Standard)で暗号化
   */
  encrypt(value : string) : string{
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  /**
   * AES(Advanced Encryption Standard)で復号化
   */
  decrypt(textToDecrypt : string){
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }

  /**
   * LocalStorage中のユーザー情報を取得する（復号化した）
   */
  get(key: string): UserInfoModel {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) {
        return {} as UserInfoModel;
      }
      const decrypted = this.decrypt(raw);
      if (!decrypted) {
        return {} as UserInfoModel;
      }
      return JSON.parse(decrypted) || ({} as UserInfoModel);
    } catch {
      return {} as UserInfoModel;
    }
  }

  /**
   * LocalStorage中のユーザー情報を更新する（暗号化した）
   */
  set(key: string, value: UserInfoModel): boolean {
    localStorage.setItem(key, this.encrypt(JSON.stringify(value)));
    return true;
  }
  
  /**
   * LocalStorage中のユーザー情報をクリアする
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  }

}
